import { ClientConfig } from "@/generated/backend/v1/config";
import { fetchApi } from "./fetchApi";

/**
 * GET /api/config: public runtime config (Firebase web config, feature flags, app env). Cached in
 * localStorage so a later start can use the last answer immediately (architecture-redesign.md
 * section 4); the network answer replaces it.
 */
const STORAGE_KEY = "abi.clientConfig";

export function readCachedConfig(): ClientConfig | undefined {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? ClientConfig.fromJson(JSON.parse(raw), { ignoreUnknownFields: true }) : undefined;
  } catch {
    return undefined;
  }
}

export async function fetchClientConfig(): Promise<ClientConfig> {
  const config = await fetchApi("/config", { response: ClientConfig, anonymous: true });
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(ClientConfig.toJson(config)));
  } catch {
    // storage full or disabled: the cache is only an optimization
  }
  return config;
}
